import Forms from '../../utils/forms/forms';
import { mapGetters } from 'vuex';
import store from './../../store';
import postalService from './../../services/postal';
import stringFormatMixin from './../../mixins/stringFormat';

export default {
  props: {
    id: {
      type: Number,
      required: false,
    },
    data: {
      type: Object,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    errors: {
      type: Object,
      required: false,
    },
    countries: {
      type: Array,
      required: true,
    },
    municipalities: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      form: new Forms({
        id: {
          value: null,
          type: 'hidden',
        },
        name: {
          value: null,
          type: 'hidden',
        },
        addressId: {
          value: null,
          type: 'hidden',
        },
        addressType: {
          value: this.id,
          type: 'hidden',
        },
        careOf: {
          value: '',
          type: 'text',
        },
        streetName: {
          value: '',
          type: 'text',
        },
        secondStreetName: {
          value: '',
          type: 'text',
        },
        postalCode: {
          value: '',
          type: 'text',
          // type: 'autocomplete',
        },
        cityName: {
          value: '',
          type: 'text',
        },
        countryId: {
          value: '',
          type: 'select',
        },
      }),
      show: false,
    };
  },
  computed: {
    ...mapGetters({
      postals: 'allPostals',
    }),
  },
  created() {
    this.loading = true;
    this.form.setTooltip('mobileNumber', this.$t('form.clients.mobileNumber.tooltip'));
    // this.form.setExtraAttr('postalCode', {
    //   remote: postalService,
    // });

    // this.form.disableField('cityName');
    this.form.setOptions('countryId', this.countries.map(c => ({ id: c.id, name: this.$t(`country.translated.${c.code}`) })));

    if (this.data) {
      this.form.assignData(this.data);
      if (this.data.streetName) {
        this.show = true;
      }
    }
  },
  watch: {
    // postals(postals) {
    //   this.form.setOptions('postalCode', postals.items.map(o => ({ name: o.postalCode })));
    // },
    errors(errors) {
      this.form.recordErrors(errors);
    },
    form: {
      handler(newValue) {
        this.$emit('update', newValue);
      },
      deep: true,
    },
    'form.streetName': function (streetName) {
      if (streetName && this.show === false) {
        this.show = true;
      }
    },

    /**
     * Watch the value of the zipcode
     */
    // 'form.postalCode': function (postalCode) {
    //   if (typeof postalCode === 'string') {
    //     if (postalCode.length > 3) {
    //       this.showCityByPostalCode(postalCode);
    //     }
    //   }
    //   if (typeof postalCode === 'object') {
    //     if (postalCode.name) {
    //       this.showCityByPostalCode(postalCode.name.toString());
    //       this.form.postalCode = postalCode.name.toString();
    //     }
    //   }
    // },
  },

  methods: {
    /**
     * Method to display the city
     */
    // showCityByPostalCode(postalCode) {
    //   if (this.postals.items.length > 0) {
    //     const postal = this.postals.items.filter(p => (
    //       postalCode === p.postalCode.toString()
    //     ))[0];
    //     this.form.cityName = postal ? postal.cityName : null;
    //   }
    // },
    destroy() {
      this.form.streetName = '';
      this.form.secondStreetName = '';
      this.form.countryId = '';
      this.form.postalCode = '';
      this.form.cityName = '';
      this.form.careOf = '';
      this.show = false;
    },
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
  },
  mixins: [
    stringFormatMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/clientAddress/clientAddress.js